import tw, { styled } from 'twin.macro'
import { Css_Text_16_24 } from '../index'

export const StyledNewsTypeWrapper = tw.div`flex`
export const StyledNewsType = styled.div(() => [
  tw`bg-accentroGray-full text-accentroWhite-full px-px-12 py-px-8 font-semibold`,
  ``,
])

export const StyledNewsTypeTranslated = styled.div(() => [
  tw`bg-accentroGray-full text-accentroWhite-full px-px-12 py-px-8 transform -translate-y-1/2 font-semibold`,
  ``,
])

export const StyledNewsDate = styled.div<{ light?: boolean }>(({ light }) => [
  Css_Text_16_24,
  tw`font-semibold`,
  light ? tw`text-accentroWhite-full` : tw`text-accentroGray-full`,
])
